import React from 'react';
import { ProductCard } from './ProductCard';
const productsData = [{
  id: 'ramo-alegria',
  name: 'Ramo Alegría',
  price: '$23.900',
  image: 'https://cdn.magicpatterns.com/uploads/unsQ2iRFqw58BRd8cjY56W/WhatsApp_Image_2026-04-15_at_23.10.29.jpg',
  accentColor: 'hover:border-yellow-200',
  rotation: 1,
  base: ['Ramo de flores', 'Globo a elección'],
  contains: ['Hermoso ramo de flores variadas', 'Globo a elección según la ocasión', 'Reparto gratis dentro del radio urbano']
}, {
  id: 'rosa',
  name: 'Desayuno Rosa',
  price: '$25.500',
  image: 'https://cdn.magicpatterns.com/uploads/8SmAJYbnT3zZnDo3SqRtzG/WhatsApp_Image_2026-04-15_at_23.04.46.jpg',
  accentColor: 'hover:border-pink-200',
  rotation: 1,
  base: ['Caja decorativa', 'Tarjeta de saludo', 'Globo según ocasión'],
  contains: ['Vaso reutilizable de café', 'Té y café', 'Café capuchino', 'Azúcar y endulzante', 'Servilletas y cubiertos', '1 Trozo de torta', '1 Sándwich de jamón queso lechuga mayo (pan ciabatta)', '1 Rollito de canela grande', '1 Factura', '1 Media luna', 'Porción fruta']
}, {
  id: 'esperanza',
  name: 'Desayuno Esperanza',
  price: '$26.500',
  image: 'https://cdn.magicpatterns.com/uploads/hJHD1y24SCJk4WL8CjaBK8/WhatsApp_Image_2026-04-15_at_22.04.34_(1).jpg',
  accentColor: 'hover:border-purple-200',
  rotation: -1,
  base: ['Globo según ocasión', 'Tarjeta de saludo', 'Caja decorativa'],
  contains: ['Tazón de cerámica', 'Té', 'Café capuchino', 'Azúcar y endulzante', 'Servilletas y cubiertos', '1 Trozo de torta', '1 Jugo AMA orgánico', '2 Mini palmeritas con chocolate', '1 Rollito de canela', '2 Alfajores de maicena', '1 Porción de fruta según stock', 'Flores de decoración']
}, {
  id: 'dedicado',
  name: 'Desayuno Dedicado a Ti',
  price: '$26.500',
  image: 'https://cdn.magicpatterns.com/uploads/6HZe3uxPHhKPAnt2p8kZSQ/WhatsApp_Image_2026-04-15_at_23.04.46_(3).jpg',
  accentColor: 'hover:border-pink-300',
  rotation: 1.5,
  base: ['Globo dependiendo la ocasión', 'Tarjeta de saludo', 'Caja decorativa con un hermoso cintón'],
  contains: ['Vaso de café', 'Té', 'Café capuchino', 'Azúcar y endulzante', 'Bombilla, servilletas, cubiertos', '2 Rollitos de canela', '1 Trozo de torta de yogurt', '1 Sándwich jamón queso lechuga mayo', '1 Leche blanca o chocolate', '1 Jugo Watts', '1 Yogurt batido', '1 Paquete de galletas salada con pote de queso crema pequeño', '2 Galletas de chips de chocolate']
}, {
  id: 'felicidad',
  name: 'Desayuno Felicidad',
  price: '$27.500',
  image: 'https://cdn.magicpatterns.com/uploads/rVXYEgpVangXVbVfWFQnL8/WhatsApp_Image_2026-04-15_at_23.04.46_(1).jpg',
  accentColor: 'hover:border-amber-200',
  rotation: -1.5,
  base: ['Caja decorativa', 'Tarjeta de saludo', 'Globo según ocasión'],
  contains: ['Vaso de café reutilizable', 'Té', 'Café instantáneo', 'Endulzante, azúcar', 'Servilletas, cubiertos de madera', '1 Sándwich jamón queso lechuga mayonesa', '1 Jugo boca ancha', '1 Leche blanca o chocolate (según stock)', '2 Rollitos de canela', '1 Trozo de torta', '1 Galleta cracker pequeña', '3 Mini alfajores de manjar']
}, {
  id: 'dulzura',
  name: 'Desayuno Dulzura',
  price: '$28.500',
  image: 'https://cdn.magicpatterns.com/uploads/vPGGu45Y1qn5vNrYQt2pDd/WhatsApp_Image_2026-04-15_at_22.04.34.jpg',
  accentColor: 'hover:border-rose-200',
  rotation: 1,
  base: ['Caja decorativa', 'Tarjeta de saludo', 'Globo según ocasión'],
  contains: ['Vaso reutilizable de café', 'Té y café', 'Café capuchino', 'Azúcar y endulzante', 'Servilletas y cubiertos', '1 Trozo de torta', '1 Sándwich de jamón queso lechuga mayo (pan integral)', '1 Rollito de canela grande', '1 Factura', '1 Media luna', '2 Alfajores', '3 Cuchufli', 'Porción fruta']
}, {
  id: 'conquista',
  name: 'Desayuno Conquista',
  price: '$31.500',
  image: 'https://cdn.magicpatterns.com/uploads/gmM4b6T1A8qVeLUCH38LrQ/WhatsApp_Image_2026-04-15_at_22.04.34_(3).jpg',
  accentColor: 'hover:border-pink-200',
  rotation: -1,
  base: ['Globo según ocasión', 'Tarjeta de saludo', 'Caja decorativa'],
  contains: ['Tazón de cerámica', 'Té', 'Café capuchino', 'Azúcar y endulzante', 'Servilletas y cubiertos', '1 Trozo de torta', '1 Sándwich jamón queso y lechuga', '1 Jugo AMA orgánico', '2 Mini palmeritas con chocolate', '1 Rollito de canela', '2 Alfajores de maicena', '1 Paquete de cuchufli rellenos de manjar', '1 Porción de fruta según stock', '1 Factura', '1 Media luna', 'Flores de decoración']
}, {
  id: 'jacinta',
  name: 'Desayuno Jacinta',
  price: '$36.500',
  image: 'https://cdn.magicpatterns.com/uploads/utT5YgFNmF2Xsr4kiisjzt/WhatsApp_Image_2026-04-15_at_22.04.34_(2).jpg',
  accentColor: 'hover:border-emerald-200',
  rotation: 1.5,
  base: ['Caja decorativa', 'Tarjeta de saludo', 'Globo'],
  contains: ['Tazón', 'Té', 'Café instantáneo', 'Endulzante', 'Azúcar', 'Servilletas y cubiertos', '1 Sándwich jamón queso salame lechuga', '1 Jugo AMA orgánico', '2 Mini palmeritas con chocolate', '2 Rollito chocolatozo', '1 Media luna', '2 Alfajores de maicena', '1 Yogurt con cereales o granola', '3 Mini trufas', '1 Posillo con fruta (según stock)']
}, {
  id: 'enamorarte',
  name: 'Quiero Volver a Enamorarte',
  price: '$39.990',
  image: 'https://cdn.magicpatterns.com/uploads/cfNfD1heG8fJtGvdihMyne/WhatsApp_Image_2026-04-15_at_23.04.46_(2).jpg',
  accentColor: 'hover:border-violet-200',
  rotation: -1.5,
  base: ['Caja decorativa', 'Flores de decoración', 'Globo según la ocasión'],
  contains: ['1 Espumante', '2 Copas', '2 Chocolates Ferrero Rocher', '3 Frascos: Aceitunas, Frutos secos, Mix de gomitas dulces']
}];
export function Products() {
  return <section className="py-24 px-6 bg-stone-50" id="productos" data-id="element-102">
      <div className="max-w-6xl mx-auto" data-id="element-103">
        <div className="text-center mb-16" data-id="element-104">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-105">
            Nuestros Desayunos
          </h2>
          <div className="w-24 h-1 bg-brand-rose/30 mx-auto rounded-full" data-id="element-106"></div>
          <p className="mt-6 text-stone-500 max-w-2xl mx-auto" data-id="element-107">
            Selecciona la opción perfecta para sorprender. Todos nuestros
            desayunos incluyen reparto gratis dentro del radio urbano.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16" data-id="element-108">
          {productsData.map(product => <ProductCard key={product.id} product={product} data-id="element-109" />)}
        </div>
      </div>
    </section>;
}